import React from 'react'
import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import image3URL from '../images/image3';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10
});
const UserDet = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    border: '1px solid #D8D0D0',
    borderRadius: '12px',
    width: '70vw'
});
const GenerateButton = styled('button')({
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '10px',
    cursor: 'pointer',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});


const ActivityInstruction = ({ handlePrevious, handleNextClick }) => {
    return (
        <MainContainer>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '98%' }}>
                <Typography color='black' style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '20px'
                }}>
                    Add extra-curricular, academic and professional activities.
                </Typography>
            </div>
            <UserDet>
                <Typography
                    style={{
                        fontSize: '14px',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        alignSelf: 'flex-start',
                        textAlign: 'left',
                        width: '100%'
                    }}>
                    <strong>For best results, please add as many activities as you can.</strong>
                    <br /><br />
                </Typography>
                <p>

                </p>
                <div style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                    <img src={image3URL} alt='activityLogo' style={{ height: '80%' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <GenerateButton
                        onClick={handlePrevious}
                    >
                        Previous
                    </GenerateButton>
                    <GenerateButton
                        onClick={handleNextClick}
                    >
                        Next
                    </GenerateButton>
                </div>
            </UserDet>
        </MainContainer>
    )
}

export default ActivityInstruction;